import { createFlagUpdatesChangeExtension } from '@spotify/plugin-confidence-flags-react';

const getSegmentName = (value: unknown): string => {
  if (typeof value === 'object' && value !== null) {
    const obj = value as Record<string, unknown>;
    return String(obj.displayName ?? 'Unknown');
  }
  return 'Unknown';
};

export const SEGMENT_CREATED_EXTENSION = createFlagUpdatesChangeExtension({
  id: 'segment-created',
  priority: 1,
  predicate: ({ change }) =>
    change.changeType === 'ADD' &&
    change.fieldPath === '/' &&
    change.fieldType === 'confidence.flags.admin.v1.Segment',
  title: () => 'Created segment',
  tag: change => ({
    tagLabel: getSegmentName(change.newValue),
    ariaLabel: 'Segment name',
  }),
  render: () => null,
});
